module.exports = __webpack_public_path__ + "src/img/icon/icon_info.8075b3f90905c87b93981a5587981988.png";